import DetalleService from "@/services/comprobantes/DetalleComprobanteService.js";

export default {
    props: {
        detalles: {
            type: Array,
            required: true
        }
    },

   
    methods: {
        agregarProducto(producto) {
            console.log(producto);

            const detalle =
                DetalleService.crearDetalleDesdeProducto(producto, this.config);

            DetalleService.agregarDetalle(this.detalles, detalle, this.config);

            this.$updateBus.$emit("showSnackBar", {
                show: true,
                color: "success",
                text: "Producto agregado",
                timeout: 1500
            });
        },

        incrementar(detalle) {
            console.log(detalle);

            DetalleService.incrementarCantidad(detalle);
        },

        decrementar(detalle) {
            DetalleService.decrementarCantidad(detalle);
        },

        eliminar(detalle) {
            DetalleService.eliminarDetalle(this.detalles, detalle);
        },

        cerrarCantidad(detalle) {
            DetalleService.normalizarCantidad(detalle);
        },


        subtotalSinIva(detalle) {
            return DetalleService.calcularSubtotalSinIva(
                detalle,
                this.config
            );
        },

        subtotalConIva(detalle) {

            console.log(detalle);

            return DetalleService.calcularSubtotalConIva(
                detalle,
                this.config
            );
        }
    }
};
